import { useEffect } from "react";
import { useFetchTemplateHistory } from "@/hooks/template-history/queries/useFetchTemplateHistory";
import { DocumentCard } from "./DocumentCard";
import { TemplateOutputDTO } from "@/features/template/types";

interface TemplateCardProps {
  template: TemplateOutputDTO;
  index: number;
  clientId?: string;
  onSelect: (template: TemplateOutputDTO) => void;
}

export function TemplateCard({
  template,
  index,
  clientId,
  onSelect,
}: TemplateCardProps) {
  const { fetchAll, items, loading } = useFetchTemplateHistory();

  useEffect(() => {
    if (clientId && template._id) {
      fetchAll({ templateId: template._id, clientId });
    }
  }, [clientId, template._id, fetchAll]);

  const hasHistory = items.length > 0;
  const lastHistory = items[0];

  return (
    <DocumentCard
      doc={template}
      index={index}
      filledDoc={
        hasHistory
          ? {
              path: "generated", // Dummy path to trigger "filled" style (blue)
              createdAt: lastHistory.createdAt,
            }
          : undefined
      }
      isLoading={loading}
      onDownload={() => onSelect(template)}
      forceAllowAction={true}
    />
  );
}
